// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SkzI","footer":"styles_footer__hstCF","passCodeTooltip":"styles_passCodeTooltip__4DuOH"};